/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AutocompleteAddressResponse as ModelsCustomerAutocompleteAddressResponse } from '../models/Models/Customer/autocomplete-address-response';
import { v3AddressesGet$Json } from '../fn/addresses/v-3-addresses-get-json';
import { V3AddressesGet$Json$Params } from '../fn/addresses/v-3-addresses-get-json';
import { v3AddressesGet$Plain } from '../fn/addresses/v-3-addresses-get-plain';
import { V3AddressesGet$Plain$Params } from '../fn/addresses/v-3-addresses-get-plain';
import { v3AddressesGet$Xml } from '../fn/addresses/v-3-addresses-get-xml';
import { V3AddressesGet$Xml$Params } from '../fn/addresses/v-3-addresses-get-xml';

@Injectable({ providedIn: 'root' })
export class AddressesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v3AddressesGet()` */
  static readonly V3AddressesGetPath = '/v3/addresses';

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3AddressesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Plain$Response(params?: V3AddressesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v3AddressesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3AddressesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Plain(params?: V3AddressesGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v3AddressesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3AddressesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Json$Response(params?: V3AddressesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v3AddressesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3AddressesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Json(params?: V3AddressesGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v3AddressesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v3AddressesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Xml$Response(params?: V3AddressesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
    return v3AddressesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v3AddressesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v3AddressesGet$Xml(params?: V3AddressesGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerAutocompleteAddressResponse> {
    return this.v3AddressesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>): ModelsCustomerAutocompleteAddressResponse => r.body)
    );
  }

}
